import { JSConn } from "@/utilities/js-conn";
import LoadingAnimation from "@/components/LoadingAnimation/LoadingAnimation";

export default {
  name: "users",
  components: {
    LoadingAnimation,
  },
  data() {
    return {
      dataLoaded: false,
      loadingMessage: "Loading Users...",
      sortBy: "name",
      fields: [
        { key: "name", label: "Name", sortable: true },
        { key: "actions", label: "Actions" },
      ],
    };
  },
  computed: {
    users: function() {
      return this.$store.getters.usersForTable;
    },
  },
  created() {
    const jsConn = new JSConn();
    this.$store.dispatch("needUsers", jsConn).then(() => {
      this.dataLoaded = true;
    });
  },
};
